export default function ContactMap() {
  return null;
}
